import { LOCALE_ES } from '@growtherapy/i18n';

// TODO: When adding a new locale here, also add:
// 1. New i18n keys in telehealth-core.json (e.g. switchYourLanguageToFrench, yourBrowserIsSetToFrench, switchToFrench)
// 2. A new case in getPromptContent() in BrowserLanguagePrompt.tsx
export const ADDITIONAL_SUPPORTED_LOCALES = [LOCALE_ES];
